import React from "react";
import { useTranslation } from "react-i18next";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import CarrierLogo from "../CarrierLogo";
import CarrierToggle from "../CarrierToggle";
import ServiceChecklist from "./ServiceChecklist";
import {
  carrierLogo,
  carrierName,
  carrierStatusText,
  isCarrierOn,
  serviceEntries,
  servicesOnCount,
} from "../../carrierHelpers";

const CarrierRow = ({ row, expanded, onExpand, busy, onToggle, onServicesChange }) => {
  const { t } = useTranslation("settings");
  const name = carrierName(row);
  const on = isCarrierOn(row);
  const total = serviceEntries(row).length;
  const status = carrierStatusText(on, servicesOnCount(row), total);
  const ExpandIcon = expanded ? MdExpandLess : MdExpandMore;

  return (
    <div>
      <div className="flex items-center gap-2.5 py-1.5 pl-[12px] pr-1">
        <CarrierLogo src={carrierLogo(row)} name={name} size="sm" dimmed={!on} />
        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-semibold leading-snug text-ui-text">{name}</div>
          {total > 0 ? (
            <button
              type="button"
              onClick={onExpand}
              aria-expanded={expanded}
              className="flex items-center gap-0.5 text-xs font-medium leading-snug text-brand"
            >
              {status}
              <ExpandIcon className="h-4 w-4" />
            </button>
          ) : (
            <div className="text-xs leading-snug text-ui-text-muted">{status}</div>
          )}
        </div>
        <CarrierToggle
          checked={on}
          onChange={onToggle}
          disabled={busy}
          label={t("carriers.showInQuotes", { name })}
        />
      </div>
      {expanded && total > 0 && (
        <div className="bg-ui-surface-sunken px-[12px] pb-[12px] pt-2.5">
          <ServiceChecklist row={row} onChange={onServicesChange} disabled={busy} />
        </div>
      )}
    </div>
  );
};

export default CarrierRow;
